import { render, staticRenderFns } from "./AreaWidget.vue?vue&type=template&id=831b90ac&scoped=true&lang=html&"
import script from "./AreaWidget.vue?vue&type=script&lang=js&"
export * from "./AreaWidget.vue?vue&type=script&lang=js&"
import style0 from "./AreaWidget.vue?vue&type=style&index=0&id=831b90ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831b90ac",
  null
  
)

export default component.exports